/** @jsxImportSource @emotion/react */
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { SpinnerBlock } from "../common/Spinner";
import { useGetKitchenCategories } from "./service/kitchen-categories-api";
import { MutateKitchenCategorySelector } from "./components/MutateKitchenCategorySelector";
import { PlaceholderBox } from "../../components/PlaceholderBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { KitchenCategoriesTable } from "./components/KitchenCategoriesTable";
import { useHandleFetchError } from "../../error-handler";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const KitchenCategoriesList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data, isLoading, error } = useGetKitchenCategories(
    organizationKeyName
  );

  useHandleFetchError(error);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Kitchen categories"
          subtitle="Manage all of your kitchen categories"
        >
          <MutateKitchenCategorySelector />
        </PageHeader>
        {data?.length === 0 || !data ? (
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <PlaceholderBox
              icon={<FontAwesomeIcon icon={solid("list")} />}
              header="No kitchen categories created yet"
              subHeader="Create your first kitchen category by pressing on create kitchen category in top right corner"
            />
          </CardBody>
        ) : (
          <KitchenCategoriesTable kitchenCategories={data} />
        )}
      </CardContainer>
    </PageWrapper>
  );
};
